"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storesImpressionsPixel = exports.storeImpressionPixel = void 0;
var Utils_1 = require("./lib/Utils");
var ViewportMonitor_1 = require("./lib/ViewportMonitor");
var statsApi_1 = require("./lib/statsApi");
var config_1 = require("./config");
var commonProperties_1 = require("./lib/commonProperties");
var _1 = require(".");
var ImpressionStoreStats = /** @class */ (function () {
    function ImpressionStoreStats(getCookie, setCookie) {
        var _this = this;
        this._newContainer = function (container) {
            var view = container.getAttribute('data-view');
            if (!view) {
                console.warn('Found impression container without [data-view]. Please check your html.');
                return;
            }
            _this._registerView(view);
        };
        this._registerView = function (view) {
            if (_this.Views[view]) {
                console.warn("View [" + view + "] is duplicated. Please check your html");
                return;
            }
            var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, Origin = _a.Origin, Platform = _a.Platform, SearchWord = _a.SearchWord, Integration = _a.Integration, PageType = _a.PageType, SearchType = _a.SearchType;
            var URL_STATS_API = config_1.getConfiguration().URL_STATS_API;
            var apiController = new statsApi_1.default(URL_STATS_API);
            apiController.InitializeStoresImpression({
                SearchCity: SearchCity,
                SearchWord: SearchWord,
                Platform: Platform,
                Origin: Origin,
                Provider: Origin,
                View: view,
                PageType: PageType,
                SearchType: SearchType,
                Integration: Integration,
            });
            _this.Views[view] = apiController;
        };
        this._pushImpression = function (item, container) {
            //@ts-ignore
            var _a = item.dataset, id = _a.id, position = _a.position;
            var StoreId = parseInt(id);
            var Position = parseInt(position);
            if (!Utils_1.isNumber(Position) || !Utils_1.isNumber(StoreId)) {
                if (!item.classList.contains('advertising')) {
                    console.warn('Error processing print element');
                    console.warn(item);
                }
                return;
            }
            //@ts-ignore
            var view = container.dataset.view;
            var apiController = _this.Views[view];
            if (apiController) {
                apiController.PushStore({
                    StoreId: StoreId,
                    Position: Position,
                    getCookie: _this.$getCookie,
                    setCookie: _this.$setCookie
                });
            }
        };
        this.Views = [];
        this.$getCookie = getCookie;
        this.$setCookie = setCookie;
        this.ViewportMonitor = new ViewportMonitor_1.default({
            containerClass: 'js-print-store-container',
            itemClass: 'js-print-store-item',
            onNewContainer: this._newContainer,
            onNewItem: this._pushImpression
        });
    }
    return ImpressionStoreStats;
}());
exports.default = ImpressionStoreStats;
exports.storeImpressionPixel = function (storeId, position, view, baseUrl) {
    return exports.storesImpressionsPixel([{ StoreId: storeId, Position: position }], view, baseUrl);
};
exports.storesImpressionsPixel = function (stores, view, baseUrl) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Provider = _a.Provider, SearchType = _a.SearchType, Integration = _a.Integration;
    var entity = {
        Stores: stores,
        View: view,
        PageType: "AMP_" + PageType,
        SearchType: SearchType,
        Provider: Provider,
        Origin: Origin,
        Integration: Integration,
        Platform: Platform || _1.Device.Mobile,
        SearchCity: encodeURIComponent(SearchCity),
        SearchWord: encodeURIComponent(SearchWord),
        UserToken: commonProperties_1.getUserTokenAMP(),
        ClientTimeStamp: commonProperties_1.getFormattedClientTimeStamp(),
        TimeZoneOffset: commonProperties_1.getTimezoneOffset()
    };
    return baseUrl + "/Store/Impressions/Pixel?entity=" + JSON.stringify(entity);
};
//# sourceMappingURL=store-impression.js.map